import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class PersonnePhysiqueDirectorContainer extends DivContainer {
	static className = "PersonnePhysiqueDirectorContainer";
	
  	constructor() {
	    super();
	    this.content = () => html`
		<row-wrapper>
			<select-from-api label="Qualité *" name="id_director_type" api-url="${window.APP_URL.api.directorType}" required value="0" null-option-text="Choisir une nature" null-option-value="0"></select-from-api>
		</row-wrapper>
		<row-wrapper>
			<select-field label="Civilité *" required name="id_personne_physique_civilite">
				<option-component label="Choisir" value="0"></option-component>
				<option-component label="Madame" value="1"></option-component>
				<option-component label="Monsieur" value="2"></option-component>
			</select-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Prénom *" required name="first_name"></text-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Nom *" required name="last_name"></text-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Adresse *" required name="address"></text-field>
		</row-wrapper>
		<autocomplete-ville></autocomplete-ville>
	    `;
	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("personne-physique-director", PersonnePhysiqueDirectorContainer);
